module.exports = __webpack_public_path__ + "img/LT112027077.9a112164.png";